var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedBasic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 11L12.2083 5.125L11.0417 3.95833L6.33333 8.66667L3.95833 6.29167L2.79167 7.45833L6.33333 11ZM1.66667 15C1.20833 15 0.815835 14.8367 0.489168 14.51C0.162501 14.1833 -0.000554141 13.7911 1.41483e-06 13.3333V1.66667C1.41483e-06 1.20833 0.163335 0.815835 0.490001 0.489168C0.816668 0.162501 1.20889 -0.000554141 1.66667 1.41483e-06H13.3333C13.7917 1.41483e-06 14.1842 0.163335 14.5108 0.490001C14.8375 0.816668 15.0006 1.20889 15 1.66667V13.3333C15 13.7917 14.8367 14.1842 14.51 14.5108C14.1833 14.8375 13.7911 15.0006 13.3333 15H1.66667Z",
    fill: "#85DBD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedBasic);
export default __webpack_public_path__ + "static/media/checked-basic.e8895a995e9f93a9018cd10d37b84128.svg";
export { ForwardRef as ReactComponent };